import React, { useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'react-redux';
import Theme from '../ui/Theme';
import AddNewTag from './AddNewTag';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  root: {
    height: '61vh',
    overflow: 'auto',
    width: '28vw',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  courseovtitle: {
    color: 'rgba(0, 0, 0, 0.4)',
    textAlign: 'left',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
  },
  courseovcontent: {
    textAlign: 'left',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',

    display: 'flex',
    alignItems: 'center',

    padding: '2px',
    color: 'black',
  },
  btnStyle: {
    height: '35px',
    width: '100%',
    marginBottom: '10px',
    backgroundColor: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
  },
  btnStyleNew: {
    height: '35px',
    width: '100%',
    marginBottom: '10px',
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
  btnStylemewtag: {
    height: '35px',
    background: Theme.palette.secondary.main,
    width: '100%',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',

    textAlign: 'center',
    letterSpacing: '0.2px',

    color: Theme.palette.quad.main,
  },
}));

const LeftBar = () => {
  const classes = useStyles();
  const [openAddTag, setOpenAddTag] = useState(false);
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);

  const openAddTagPopup = () => {
    setOpenAddTag(true);
  };
  const handleCloseAddNewTag = () => {
    setOpenAddTag(false);
  };

  return (
    <div className={classes.root}>
      <Grid style={{ width: '26vw' }} container direction="column" justifyContent="flex-start" alignItems="flex-start">
        <Grid item>
          <Image src={journeyDetails.thumbnail} alt="img" style={{ maxWidth: '26vw', width: '26vw' }} />
        </Grid>
        <Grid item style={{ marginTop: '28px' }}>
          <p className={classes.courseovtitle}>Course Overview</p>
          <p className={classes.courseovcontent}>{journeyDetails.description}</p>
        </Grid>

        <Grid item>
          <p className={classes.courseovtitle}>Journey Goal</p>
          <p className={classes.courseovcontent}>{journeyDetails.goal}</p>
        </Grid>
        <Grid item>
          <p className={classes.courseovtitle}>Skill level</p>
        </Grid>

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item style={{ width: '30%' }}>
            <Button
              variant="contained"
              style={{
                backgroundColor:
                  journeyDetails.skillLevel === 'novice' ? Theme.palette.primary.main : Theme.palette.secondary.main,
                color:
                  journeyDetails.skillLevel === 'novice' ? Theme.palette.secondary.main : Theme.palette.primary.main,
              }}
              disableElevation
              className={classes.btnStyle}
            >
              Beginner
            </Button>
          </Grid>
          <Grid item style={{ width: '30%' }}>
            <Button
              variant="contained"
              style={{
                backgroundColor:
                  journeyDetails.skillLevel === 'intermediate'
                    ? Theme.palette.primary.main
                    : Theme.palette.secondary.main,
                color:
                  journeyDetails.skillLevel === 'intermediate'
                    ? Theme.palette.secondary.main
                    : Theme.palette.primary.main,
              }}
              disableElevation
              className={classes.btnStyle}
            >
              Intermediate
            </Button>
          </Grid>
          <Grid item style={{ width: '30%' }}>
            <Button
              variant="contained"
              style={{
                backgroundColor:
                  journeyDetails.skillLevel === 'expert' ? Theme.palette.primary.main : Theme.palette.secondary.main,
                color:
                  journeyDetails.skillLevel === 'expert' ? Theme.palette.secondary.main : Theme.palette.primary.main,
              }}
              disableElevation
              className={classes.btnStyle}
            >
              Expert
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <p className={classes.courseovtitle}>Journey Tags</p>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
              {journeyDetails?.journeyTags &&
                journeyDetails?.journeyTags?.map((item) => (
                  <Grid item>
                    <Button className={classes.btnStyle} color="primary" value={item.id}>
                      {item.title}
                    </Button>
                  </Grid>
                ))}
              <Grid item>
                <Button
                  variant="contained"
                  onClick={openAddTagPopup}
                  disableElevation
                  className={classes.btnStylemewtag}
                  startIcon={<AddIcon />}
                >
                  Add Journey Tag
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {openAddTag && <AddNewTag open type="journey" close={handleCloseAddNewTag} />}
    </div>
  );
};

export default LeftBar;
